import { render } from "./FukumojiSource.vue?vue&type=template&id=06063a31&scoped=true&ts=true"
import script from "./FukumojiSource.vue?vue&type=script&lang=ts"
export * from "./FukumojiSource.vue?vue&type=script&lang=ts"

import "./FukumojiSource.vue?vue&type=style&index=0&id=06063a31&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06063a31"]])

export default __exports__